<template>
  <section class="section container">
    <div class="box">
      <template v-if="payment['novel_id'] !== ''">
        <h1 class="title has-text-centered">เลือกการสนับสนุน</h1>
        <h2 class="subtitle has-text-centered">{{ novelSelected.name }}</h2>
        <payment-step :step=step></payment-step>
      </template>
      <template v-else>
        <h1 class="title has-text-centered">เลือกนิยายที่ต้องการสนับสนุน</h1>
      </template>
      <template v-if="payment['novel_id'] === ''">
        <novels v-on:select="selectedNovel" is-select-button></novels>
      </template>
      <template v-else-if="payment['subscription_plan_id'] === ''">
        <step1 v-model="planSelected" :list="novelSelected.subscriptions" :novel="novelSelected"></step1>
      </template>
      <template v-else-if="paymentCreated === null">
        <step2 v-model="payment['payment_method']"></step2>
      </template>
      <template v-else-if="paymentCreated !== null">
        <div v-show="paymentCreated.status !== 'completed'">
          <donate :accounts="novelSelected.donate[paymentCreated['payment_method']]"></donate>
          <br>
          <h1 class="title has-text-centered">โปรดโอนเงินและแนบหลักฐานการชำระเงินด้านล่าง</h1>
        </div>
        <payment-detail :payment="paymentCreated" :novel="novelSelected" :subscription="planSelected" hasContact></payment-detail>
        <br>
        <router-link class="button is-emerald is-fullwidth" to="/payments">ประวัติการสนับสนุน</router-link>
      </template>
      <template v-else>
        <h1 class="title has-text-centered">Something wrong.</h1>
        <h2 class="subtitle has-text-centered">Please contract adminitrator. or send message to
          <a class="button is-primary" href="https://m.me/xianni.thai">ADMIN PAGE</a>
        </h2>
      </template>
    </div>
  </section>
</template>

<script>
import PaymentStep from '@/components/PaymentStep'
import Novels from '@/views/Novels'
import { db } from '@/firebase.config'
import { get } from 'vuex-pathify'
import firebase from '@firebase/app'
const Step1 = () => import(/* webpackChunkName: "steps" */ '@/components/steps/Step1.vue')
const Step2 = () => import(/* webpackChunkName: "steps" */ '@/components/steps/Step2.vue')
const Step3 = () => import(/* webpackChunkName: "steps" */ '@/components/steps/Step3.vue')
const PaymentDetail = () => import(/* webpackChunkName: "payment_detail" */ '@/components/PaymentDetail')
const Donate = () => import(/* webpackChunkName: "donate" */ '@/views/Donate')

export default {
  components: {
    Novels,
    PaymentStep,
    Step1,
    Step2,
    Step3,
    PaymentDetail,
    Donate
  },
  props: {
    initialSelectedNovel: Object
  },
  data () {
    return {
      paymentCreated: null,
      payment: {
        status: '',
        'novel_id': '',
        'payment_method': '',
        'subscription_plan_id': ''
      },
      novelSelected: this.initialSelectedNovel,
      planSelected: {},
      isCreating: false
    }
  },
  computed: {
    step () {
      if (this.isEmpty(this.novelSelected)) { return 0 }
      if (this.isEmpty(this.planSelected)) { return 1 }
      if (this.payment['payment_method'] === '') { return 2 }
      if (this.payment.file === '') { return 3 }
      if (this.payment.status !== 'completed') { return 4 }
      return 1
    },
    user: get('user')
  },
  firestore () {
    return {
      novels: db.collection('novels')
    }
  },
  methods: {
    isEmpty (obj) {
      return Object.keys(obj).length === 0
    },
    selectedNovel (novel) {
      var paymentSameDay = this.$root.payments
        .filter(payment => this.isPaymentSameDay(payment))
        .filter(payment => payment.status !== 'completed')
        .filter(payment => payment['novel_id'] === novel.id)
      if (paymentSameDay.length > 0) {
        this.$dialog.alert({
          title: 'คำเตือน!',
          message: 'ท่านได้สร้างรายการที่ยังไม่เสร็จสมบูรณ์ภายในวันเดียว กรุณาใช้อันเดิมในการอ้างอิง',
          type: 'is-warning',
          confirmText: 'ประวัติ',
          onConfirm: () => { this.$router.push('/payments') }
        })
      } else {
        this.novelSelected = novel
      }
    },
    isPaymentSameDay (payment) {
      var date = payment.date.toDate()
      var today = new Date()
      return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getYear() === today.getYear()
    },
    createPayment (payment) {
      if (this.isCreating) { return }
      this.isCreating = true
      db.collection('payments')
        .add({ ...payment,
          'user_email': this.user.email,
          uid: this.user.uid,
          date: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then((docRef) => {
          this.isCreating = false
          this.$bind('paymentCreated', db.collection('payments').doc(docRef.id))
        })
        .catch(error => this.showPopup(`Error create payment: ${JSON.stringify(error)}`))
    },
    showPopup (content) {
      this.$toast.open({ message: content })
    }
  },
  created () {
    this.$watch('payment', (newValue, oldValue) => {
      if (newValue['payment_method'] !== '' && this.paymentCreated === null) {
        newValue.status = 'waiting_transfer'
        this.createPayment(newValue)
      }
    }, { deep: true })
    if (this.novelSelected) {
      this.payment['novel_id'] = this.novelSelected.id
    }
  },
  watch: {
    novelSelected (newValue) {
      this.payment['novel_id'] = newValue.id
    },
    planSelected (newValue) {
      this.payment['subscription_plan_id'] = newValue.id
      this.payment['amount'] = newValue.price
    }
  }
}
</script>

<style lang="scss">

</style>
